<template>
        <div class="container d-flex h-100 justify-content-center">
            <div class="card my-auto w-25 bg-transparent border-0">
                <div class="card-body">
                    <b-form @submit.prevent="onSubmit">
                        <b-form-group label="Email" :invalid-feedback="fieldError('email')" :state="fieldState('email')" :disabled="sending">
                            <b-input type="email" v-model="form.email" name="email" :state="fieldState('email')" required autofocus autocomplete="username"></b-input>
                        </b-form-group>

                        <b-form-group label="Пароль" :invalid-feedback="fieldError('password')" :state="fieldState('password')" :disabled="sending">
                            <b-input type="password" v-model="form.password" required autocomplete="current-password"></b-input>
                        </b-form-group>

                        <b-form-group>
                            <b-form-checkbox name="remember" v-model="form.remember" :disabled="sending">
                                Запомнить
                            </b-form-checkbox>
                        </b-form-group>

                        <b-form-group class="mb-0" :disabled="sending">
                            <b-button type="submit" block variant="outline-primary">
                                Вход
                            </b-button>
                        </b-form-group>
                    </b-form>
                </div>
            </div>
        </div>
</template>

<script>
export default {
  data () {
    return {
      sending: false,
      form: {
        email: null,
        password: null,
        remember: false
      }
    }
  },
  methods: {
    onSubmit () {
      this.sending = true
      this.$inertia.post('/login', this.form)
        .then(() => { this.sending = false })
    }
  }
}
</script>

<style>
    body,html {
        height: 100% !important;
    }
</style>
